if (!customElements.get('cd-slider')) {
  class CarplayDiscountSlider extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.dots = [...this.querySelectorAll('[data-slide-to]')];
      if (this.slides.length < 2) return;
      this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.addEventListener('click', (event) => {
        const next = event.target.closest('[data-slide-next]');
        const prev = event.target.closest('[data-slide-prev]');
        const dot = event.target.closest('[data-slide-to]');
        if (next) this.show(this.index + 1);
        if (prev) this.show(this.index - 1);
        if (dot) this.show(Number(dot.dataset.slideTo));
      });
      this.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') this.show(this.index + 1);
        if (event.key === 'ArrowLeft') this.show(this.index - 1);
      });
      this.addEventListener('mouseenter', () => this.pause());
      this.addEventListener('mouseleave', () => this.resume());
      this.addEventListener('focusin', () => this.pause());
      this.addEventListener('focusout', () => this.resume());
      if (this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) this.resume();
    }
    disconnectedCallback() { this.pause(); }
    show(index) {
      this.pause();
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        slide.inert = !active;
      });
      this.dots.forEach((dot, i) => {
        const active = i === this.index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
      this.resume();
    }
    pause() { if (this.timer) window.clearInterval(this.timer); this.timer = null; }
    resume() {
      this.pause();
      if (this.dataset.autoplay === 'true' && !this.matches(':hover') && !this.querySelector(':focus')) {
        const speed = Math.max(4000, Number(this.dataset.speed) || 6000);
        this.timer = window.setInterval(() => this.show(this.index + 1), speed);
      }
    }
  }
  customElements.define('cd-slider', CarplayDiscountSlider);
}
